import { UnifiedGraftModelType } from '@graftcode/protocol'

type ProtocolKey = keyof typeof UnifiedGraftModelType

function isTypeUsageNodeKindKey(key: ProtocolKey): boolean {
  return typeof UnifiedGraftModelType[key] === 'number' && key.startsWith('TYPE_USAGE_')
}

const typeUsageNodeKindKeys = (Object.keys(UnifiedGraftModelType) as ProtocolKey[]).filter(isTypeUsageNodeKindKey)

/** TYPE_USAGE_* keys from protocol; use for comparison with getUnifiedGraftModelType(node). */
export const TYPE_USAGE_NODE_KIND = Object.fromEntries(typeUsageNodeKindKeys.map((k) => [k, k])) as {
  [K in (typeof typeUsageNodeKindKeys)[number]]: K
}

export type TypeUsageNodeKind = (typeof TYPE_USAGE_NODE_KIND)[keyof typeof TYPE_USAGE_NODE_KIND]
